import { render, staticRenderFns } from "./Troubleshooting.vue?vue&type=template&id=007b07d0&scoped=true&"
import script from "./Troubleshooting.vue?vue&type=script&lang=js&"
export * from "./Troubleshooting.vue?vue&type=script&lang=js&"
import style0 from "./Troubleshooting.vue?vue&type=style&index=0&id=007b07d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007b07d0",
  null
  
)

export default component.exports